var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-padding page-sidebar users-page"},[_c('data-table'),_c('transition',{attrs:{"name":"form-right"}},[(_vm.showInfo)?_c('user-info'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }